jQuery(document).ready(function ($) {

  // faq
  $(".custom-accordion .accordion_head").click(function () {
    const $wrapper = $(this).closest(".accordion-wrapper");
    $(".accordion_body").slideUp(300);
    $(".plusminus").text("+");
    $(".accordion-wrapper").removeClass("active");
    if (!$(this).next(".accordion_body").is(":visible")) {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text("–");
      $wrapper.addClass("active");
    }
  });
  
});

jQuery(document).ready(function($) {

	var owl = $(".reviews .owl-carousel");
	  owl.owlCarousel({
		items: 2,
		margin: 20,
		loop: true,
		nav: false,
		responsive: {
		  1: {
			items: 1
		  },
		  768: {
			items: 2
		  }
		},
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		dots: false
	  });
	
});